
import { defineComponent, PropType, computed, reactive, onMounted, toRaw, watch } from "vue";
import Bus from "@/bus";
export default defineComponent({
  props: {
      modelValue: {
         type: [String, Number],
         default: "",
      },
      data: {
         type: Array as PropType<any[]>,
         default: () => [],
      },
      props: {
         type: Object,
         default: () => {
            return {
               label: "projectName",
               id: "id",
            };
         },
      },
   },
   setup(props, context) {
      const searchParams: any = reactive({
         projectYear:'',
         projectName:'',
         height:'100px',
         dataList:[],
      });

      watch(
			() => props.data,
			(val) => {
            val.forEach((item:any)=>{ 
               if(item[props.props.id] == props.modelValue){
                  item.isActive = true;
               }else{
                  item.isActive = false;
               }
            });
            searchParams.dataList = val;
			}
		);
      watch(
			() => props.modelValue,
			(val) => {
            props.data.forEach((item:any)=>{ 
               if(item[props.props.id] == val){
                  item.isActive = true;
               }else{
                  item.isActive = false;
               }
            });
			}
		);

      const changeYearFn = ()=>{
         searchParams.dataList = props.data.filter((item: any)=>{ return item.projectName.indexOf(searchParams.projectName) !== -1 && (searchParams.projectYear?item.year == searchParams.projectYear:true) });
      }

      const changeNamgeFn = ()=>{
         searchParams.dataList = props.data.filter((item: any)=>{ return item.projectName.indexOf(searchParams.projectName) !== -1 && (searchParams.projectYear?item.year == searchParams.projectYear:true) });
      }

      const clickItemFn = (item:any)=>{
         Bus.$emit('update:modelValue', item[(props as any).id]);
         Bus.$emit('itemClick',item);
         context.emit('parentNodeClick',item); 
         searchParams.dataList.forEach((oItem:any)=>{ 
            if(item.id !== oItem.id){
               oItem.isActive = false; 
            }
         });
         item.isActive = !item.isActive; 
      }

      onMounted(() => {
         searchParams.height = window.innerHeight - 220 +'px';
         window.onresize = ()=>{
            searchParams.height = window.innerHeight - 220 +'px';
         }
      });
      return {
         searchParams,
         changeYearFn,
         changeNamgeFn,
         clickItemFn
      };
   },
});
